import { render } from "./AppleLabelGrid.vue?vue&type=template&id=349f096e"
import script from "./AppleLabelGrid.vue?vue&type=script&lang=js"
export * from "./AppleLabelGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__